export default "__VITE_ASSET__CDyFNVCx__"